<ion-content [fullscreen]="true">
  <ion-grid>
    <ion-row>
      <ion-col size="12" class="center-content ion-padding">
        <div class="headerimage">
          <img src="/assets/img/Ishavskraftlogo.svg" />
        </div>
      </ion-col>
    </ion-row>
    @if (loading) {
    <ion-row>
      <ion-col class="text-center">
        <ion-spinner name="dots"></ion-spinner>
      </ion-col>
    </ion-row>
    } @else {
    <ion-row>
      <ion-col size="12" class="center-content loginSection">
        <ion-row>
          <ion-col size="12" class="center-content">
            <ion-row class="loginbox flexCenter" (click)="login()">
              <ion-col size="8">
                <div>Logg inn</div>
              </ion-col>
              <ion-col size="4" class="imgContainer">
                <img
                  style="height: 100%"
                  src="/assets/img/ISH_login.svg"
                /><br />
              </ion-col>
            </ion-row>
          </ion-col>
          <ion-col size="12" class="center-content">
            <ion-row class="loginbox nybruker flexCenter" (click)="nybruker()">
              <ion-col size="8">
                <div>Opprett ny bruker</div>
              </ion-col>
              <ion-col size="4" class="imgContainer">
                <img
                  style="height: 100%"
                  src="/assets/img/ISH_NyBrukersvg.svg"
                /><br />
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>
      </ion-col>

      <ion-col size="12" class="center-content">
        <ion-row>
          <ion-col size="12">
            <ion-row
              *ngFor="let article of forsideArticles"
              class="ion-margin-bottom articleCard"
            >
              <ion-col
                class="abstract flex"
                size="12"
                size-sm="8"
                size-md="6"
                size-lg="6"
                size-xl="6"
              >
                <h2>{{ article.title }}</h2>
                <p>{{ article.lead }}</p>
                <ion-button
                  class="selected"
                  (click)="navToArticle(article.slug.current)"
                >
                  Trykk for å lese
                  <span
                    class="fas fa-long-arrow-alt-right"
                    style="padding-left: 5px"
                  ></span>
                </ion-button>
              </ion-col>
              <ion-col
                size="12"
                size-sm="4"
                size-md="6"
                size-lg="6"
                size-xl="6"
                class="image"
                [style.background-image]="getBackground(article.image.src)"
              >
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row>
    }
  </ion-grid>
  <div class="tab-content-bottom-margin"></div>
</ion-content>
